import { Navigate } from 'react-router-dom';
import LoginComponent from '../../components/login/LoginComponent';
import AnimatedBackground from '../../components/AnimatedBackground';
import { useUserContextController } from '../../context/UserContext';
import { URL_PATHNAMES } from '../../components/routes/AppRoutes';

const LoginPage = () => {
  const [userContext] = useUserContextController();
  const { user } = userContext;

  if (user) {
    return <Navigate to={URL_PATHNAMES.CAMPAIGN} replace />;
  }

  return (
    <AnimatedBackground>
      <LoginComponent />
    </AnimatedBackground>
  );
};

export default LoginPage;
